import { MagnifyingGlass } from '@phosphor-icons/react';
import { Dialog } from '@radix-ui/react-dialog';

import { DialogContent, DialogOverlay, DialogPortal } from '../ui/Dialog';

import { cn } from '../utils/cn';

import * as styles from './SearchModal.css';
import type { SearchModalElementProps, SearchResult } from './SearchModal.types';

function SearchResultItem({ result }: { result: SearchResult }) {
  return (
    <a href={result.pathname}>
      <div className={styles.searchResult}>
        <div className={styles.searchResultTitle}>{result.title}</div>
        {result.description && <div className={styles.searchResultDescription}>{result.description}</div>}
      </div>
    </a>
  );
}

export function SearchModalElement({
  open,
  setOpen,
  results,
  search,
  setSearch,
  hasMore,
  onLoadMore,
}: SearchModalElementProps) {
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogPortal>
        <DialogOverlay />
        <DialogContent
          className={cn(styles.navbarDialogContent, 'top-[64px] sm:top-[64px] translate-y-0 sm:translate-y-0')}
        >
          <div className={styles.navbarDialogContainer}>
            <div className={styles.navbarSearch}>
              <MagnifyingGlass className="w-4 h-4" />
              <input
                type="text"
                placeholder="Search..."
                className={cn(styles.navbarSearchInput, 'focus:outline-none focus:ring-0')}
                value={search}
                onChange={(e) => setSearch?.(e.target.value)}
              />
            </div>
            {results && results.length > 0 && <hr className={styles.searchResultsSeparator} />}
            {results && results.length > 0 && (
              <div className={styles.searchResults}>
                {results?.map((result) => (
                  <SearchResultItem key={result.id} result={result} />
                ))}
              </div>
            )}
            {hasMore && onLoadMore && (
              <div className="flex justify-center px-2 pb-2">
                <button
                  type="button"
                  className="px-4 py-2 text-sm font-medium cursor-pointer bg-[var(--wt-primary-color,#030712)] text-[var(--wt-text-on-primary-color,#F9FAFB)] rounded-[var(--wt-border-radius,8px)]"
                  onClick={onLoadMore}
                >
                  Load more
                </button>
              </div>
            )}
          </div>
        </DialogContent>
      </DialogPortal>
    </Dialog>
  );
}
